export const getOrderAmount = (orderList, transportation) => {
  return orderList.reduce((total, element) => {
    if (element.transport === transportation && element.checked) {
      return total + (element.totalFob || 0);
    }
    return total;
  }, 0);
};
